import React, { useMemo } from 'react';
import { CommandBarGenericUI } from '@cube3/ui/src/library/CommandBar/CommandBarUI';
import { useModalActions } from '../../../Modals/modalActions';
import { ResourceIdentifier } from '@cube3/common/model/resource-types';
import { useButtonConfig } from '../../../CommandBar/useButtonConfig';

import { attachContractButtonFactory } from './button-factories/attachContractButtonFactory';
import { detachContractButtonFactory } from './button-factories/detachContractButtonFactory';
import { EditAttachedContractButtonFactory } from './button-factories/EditAttachedContractButtonFactory';
import { isMobile } from 'react-device-detect';

interface Props {
  contract?: ResourceIdentifier;
  parentResource: ResourceIdentifier;
  //first level/layer of slider or second
  mobileSliderLevel?: 'first' | 'second';
}

export const AttachedContractsCommandBar: React.FC<Props> = (props) => {
  const { contract, parentResource, mobileSliderLevel } = props;

  const modalActions = useModalActions();

  const primaryButtonFactories = useMemo(() => {
    if (isMobile) {
      return [
        attachContractButtonFactory(() =>
          modalActions.openModal(
            'attach_contract_prompt',
            { parentResource },
            false
          )
        )
      ];
    } else {
      return [
        attachContractButtonFactory(() =>
          modalActions.openModal(
            'attach_contract_prompt',
            { parentResource },
            false
          )
        ),
        detachContractButtonFactory(
          () =>
            modalActions.openModal(
              'detach_contract_prompt',
              {
                parentResource,
                contract
              },
              false
            ),
          contract
        )
      ];
    }
  }, [contract, parentResource, modalActions]);

  const secondaryButttonFactories = useMemo(() => {
    if (isMobile) {
      return [
        detachContractButtonFactory(
          () =>
            modalActions.openModal(
              'detach_contract_prompt',
              {
                parentResource,
                contract
              },
              false
            ),
          contract
        ),
        EditAttachedContractButtonFactory(
          () =>
            modalActions.openModal('edit_contract', {
              contractId: contract.id
            }),
          contract
        )
      ];
    } else {
      return [
        EditAttachedContractButtonFactory(
          () =>
            modalActions.openModal('edit_contract', {
              contractId: contract.id
            }),
          contract
        )
      ];
    }
  }, [contract, modalActions]);

  const primaryButtonConfig = useButtonConfig(primaryButtonFactories);
  const secondaryButtonConfig = useButtonConfig(secondaryButttonFactories);

  return (
    <>
      {isMobile ? (
        <>
          {mobileSliderLevel === 'first' ? (
            <CommandBarGenericUI primaryButtonsConfig={primaryButtonConfig} />
          ) : (
            <div style={{ marginLeft: '-10px' }}>
              <CommandBarGenericUI
                primaryButtonsConfig={secondaryButtonConfig}
              />
            </div>
          )}
        </>
      ) : (
        <CommandBarGenericUI
          primaryButtonsConfig={primaryButtonConfig}
          secondaryButtonsConfig={secondaryButtonConfig}
        />
      )}
    </>
  );
};
